<template>
  <div v-if="getScoreData" class="scorecard">
    <!-- tennis score card -->
    <div v-if="marketId == 2">
      <div class="player-a player">
        <div v-if="getSelections?.length > 1" class="player-name">
          {{ getSelections?.[0]?.name }}
        </div>
        <div class="score">
          <div v-if="getSelections?.[0]?.serving" class="serving">*</div>
          <div class="sets">
            <div class="current">{{ getSelections?.[0]?.score?.current }}</div>
            <span
              v-for="(set, index) in getSelections?.[0]?.score?.sets"
              :key="index"
              >{{ set }}</span
            >
          </div>
        </div>
      </div>
      <div class="player-b player">
        <div v-if="getSelections?.length > 1" class="player-name">
          {{ getSelections?.[1]?.name }}
        </div>
        <div class="score">
          <div v-if="getSelections?.[1]?.serving" class="serving">*</div>
          <div class="sets">
            <div class="current">{{ getSelections?.[1]?.score?.current }}</div>
            <span
              v-for="(set, index) in getSelections?.[1]?.score?.sets"
              :key="index"
              >{{ set }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- football score card -->
    <div v-else>
      <div class="player-a player">
        <div v-if="getTeamsForFootball?.length > 1" class="player-name">
          {{ getTeamsForFootball?.[0]?.name }}
        </div>
        <div v-if="getTeamsForFootball?.[0]?.score" class="football-score">
          <span>{{ getTeamsForFootball?.[0]?.score }}</span>
          <span class="penalty-score">
            ({{ getTeamsForFootball?.[0]?.penaltyScore || 0 }})
          </span>
        </div>
      </div>
      <div class="player-b player">
        <div v-if="getTeamsForFootball?.length > 1" class="player-name">
          {{ getTeamsForFootball?.[1]?.name }}
        </div>
        <div v-if="getTeamsForFootball?.[1]?.score" class="football-score">
          <span>{{ getTeamsForFootball?.[1]?.score }}</span>
          <span class="penalty-score">
            ({{ getTeamsForFootball?.[1]?.penaltyScore || 0 }})
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    marketId: {
      type: [String, Number],
      default: 2,
      required: true
    }
  },
  data() {
    return {
      tennisScore: {
        player1: 0,
        player2: 0
      },
      stats: null,
      selections: []
    }
  },
  computed: {
    ...mapState({
      getScoreData: (state) => state.matchInside.getVideoUrlRtmp
    }),
    getSelections() {
      return this.getScoreData?.stats?.selections
    },
    getTeamsForFootball() {
      return this.getScoreData?.stats?.teams
    }
  },
  watch: {},
  methods: {
    getSelectionData() {
      if (this.getScoreData?.selections) {
        return this.getScoreData?.selections
      }
    }
  }
}
</script>
<style>
.player,
.sets,
.score {
  display: flex;
}
.sets {
  gap: 5px;
}
.score {
  gap: 10px;
  height: 30px;
}
.player {
  justify-content: space-between;
}
.scorecard {
  min-height: 90px;
  padding: 0 4px;
  background-color: #212121;
}
.sets > span {
  height: 20px;
  width: 20px;
  text-align: center;
}
.serving {
  font-size: 20px;
  font-weight: 900;
}
/* .penalty-score {
  margin-left: 5px;
}*/
</style>
